module.exports = "<section class=\"search\">\n  <div>\n    <span [ngClass]=\"{'focus': searchFocus}\" class=\"material-icons\">search</span>\n    <input #searchInput type=\"text\" (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\" (keyup)=\"onKeyUp($event)\" placeholder=\"Search\">\n    <span *ngIf=\"searchFocus\" [ngClass]=\"{'focus': searchFocus}\" class=\"material-icons clear\" (click)=\"clearSearch($event)\">close</span>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search-list/search-list.component.html
// module id = ./src/app/shared/components/search-list/search-list.component.html
// module chunks = main